import {FA} from './fotoAlbom';

var TopMenu=[];
addEventListener("load",function(){
	var fa = new FA;
	var isMobile=((document.ontouchstart === null)?(1):(0)); 
	//Верхнее меню не видимо, подготавливаем к появлению
	//document.getElementById('mobTopMenu').style.display='none';

	//обработчик открывающий меню мобильный вариант
	document.getElementById('toggleMenu').onclick=toggleMenu;
	//обработчик формы поиска в шапке
	document.querySelector(".topHeader4 i").onclick=formSearchSubmit;

	//обработчики открывающие модальное окно
	document.getElementById('basket').onclick=basketLst;
	//обработчики закрывающие модальное окно и submit
	var x = document.querySelectorAll(".modal");
	for (var i = 0; i < x.length; i++){
		x[i].querySelector("form").onsubmit = formSubmit;
		x[i].querySelector(".modalClose").onclick=function(e){//Закрываем модальное окно
			var el=e.target;
			var modalWin = el.parentNode.parentNode.parentNode;
			modalWin.style.opacity='0';
			modalWin.style.pointerEvents='none';
			var formAlert=modalWin.querySelector("form");
			formAlert.innerHTML='';
		}
	}

	reSizeH("#mainMenu >.contentBox");
	reSizeH("#news >.contentBox");
	reSizeH("#argmntsBox >.contentBox");

	//Подсветка ссылок при совпадении их урл с урл страницы
	var addr=location.pathname+location.search;
	if(addr=='/')	var el = document.querySelector(".topMenu > a:nth-child(2)"); //В топ меню Главная это вторая по счету ссылка 
	else var el = document.querySelector('a[href*="'+addr+'"]');
	if(!!el){ 
		if(el.classList.contains('menuItems')){//http://ruseller.com/lessons.php?rub=32&id=2131
			el.classList.add("menuItemsCs");
			//el.style.background = '#db4689';
			el.style.borderLeft = '1px solid #db0f6a';
			//el.style.borderTop = '1px solid #db0f6a';
			//el.style.borderBottom = '1px solid #db0f6a';
		}else if(el.classList.contains('contentBox')){//Блоки в sideBar сделаны с помощью <a class=contentBox
			//el.style.display = 'none'; //скрыть новость в sideBar, если она в центре.		
		}else{
			//el.style.background = '#eee';
			//el.style.color = '#db0f6a';
			el.style.textDecoration = 'underline';
		}
		//el.style.border = '1px solid #bfd2e6';
		//el.style.borderRight = '1px solid #2a6cb6';
		//el.style.borderBottom = '1px solid #fff';
		//el.style.color = '#444';

		el.style.cursor = 'default';
	}
}, true);//addEventListener("load",function)

window.onresize = function(){
	reSizeH("#mainMenu >.contentBox");
	reSizeH("#news >.contentBox");
	reSizeH("#argmntsBox >.contentBox");
};

function reSizeH(s){
	//alert(s);
	var divs = document.querySelectorAll(s);
	var maxHeight=0;
	var t;
    for(var j = 0; j < divs.length; j++){
		//divs[j].removeAttribute("height");
		divs[j].style.height = 'auto';
		if((t = divs[j].offsetHeight) >maxHeight) maxHeight=t;
    }
	//console.log('maxHeight=',maxHeight);
    for(var j = 0; j < divs.length; j++) divs[j].style.height=maxHeight+'px';
}

function isTel(el){
	var p=el.parentNode;
	//.querySelector("div.formMsg").value
	//var msg=p.getElementsByClassName('formMsg')[0];
	var elTel=p.querySelector("input[name='tel']");
	var tel=elTel.value;
	//console.log(tel);
	//var msg=document.getElementById('MsgTel');
	//var tel=document.getElementById('Tel').value;
	tel=tel.replace(/[^\d]+/g,'');
	if(tel.length != 11){
		elTel.title='Например: 8-34241-491-48';
		//elTel.style.border="1px solid red";
		//elTel.style.borderTop="1px solid #666";
		//elTel.style.boxShadow="0 0 5px red";

		//msg.style.color = 'red';
		//msg.innerHTML='Не верный номер';
		return false;
	}else{
		//msg.innerHTML='';
		return true;
	}
}

function AJAXSubmit(oFormElement,callBack){//Общий сабмит для HTML форм (<FORM), upload фото
	if (!oFormElement.action) { return; }
	//document.getElementById('pgId').value=pid;
	//oFormElement.querySelector('.pgId').value=pid;
	//oFormElement.pgId.value=pid;
	var oReq = new XMLHttpRequest();
	oReq.onload = callBack;
	oReq.open("post", oFormElement.action);
    oReq.send(new FormData(oFormElement));
}

function formSubmit(form){
	var modalWin;
	modalWin = document.getElementById("price");
	modalWin.style.opacity='0';
	modalWin.style.pointerEvents='none';

	return false;
	//var p=el.parentNode;
	//alert(form);
	var elTel=form.querySelector("input[name='tel']");
	var tel=elTel.value;
	var elEmail=form.querySelector("input[name='email']");
	var email=elEmail.value;
	if(email=='' && tel==''){
		elEmail.title='Пожалуйста, введите емайл.';
		elEmail.style.boxShadow="0 0 5px red";
		//alert('Пожалуйста, введите Ваш телефон или емайл.');
		return false;
	}
	//var msg=document.getElementById('MsgTel');
	//var tel=document.getElementById('Tel').value;
	//document.querySelector("input[name='elementname']").value;
	AJAXSubmit(form,CallBackGetPrice);
	eraseCookie('zakaz');
	//form.innerHTML='';
	return false;
}
function CallBackGetPrice(){//Ответ от PHP после отправки письма
	var t=this.responseText;
	var res=JSON.parse(t);
	if(res.status='Success'){
		window.location='./#close';
		alert('Заявка отправлена, в ближайщее время мы обязательно свяжемся с Вами.');
	}
	else alert(res.status);
}

function toggleMenu(){
	//var mobTopMenu=document.getElementById("mobTopMenu");
	var m=document.getElementById('mobTopMenu');
	if(m.style.display=='none') m.style.display='block';
	else m.style.display='none';
//	if(!document.getElementById("mainMenuLst")){
	if(!document.querySelector("#mobTopMenu #mainMenuLst")){
		//var mobTopMenuBox=document.getElementById("mobTopMenuBox");
		//var sideBar=document.getElementById("sideBar");
		//mobTopMenu.replaceWith(sideBar);
		//sideBar.style.display='block';
		ajax_get('menuMobile.php?id=24', function(d){
			//console.log("d=",d);    
			m.innerHTML=d;
			var mainLst=document.getElementById("mainMenuLst");
			var catLst=document.getElementById('catMenuLst');
    
			var catHeader=document.querySelector(".catName > div:nth-child(1)");
			var mainHeader=document.querySelector(".catName > div:nth-child(2)");
			mainHeader.onclick=function(){
				console.log("mainHeader.onclick="+mainLst.style.display);
				if(mainLst.style.display=='none'){
					catLst.style.display='none';
					mainLst.style.display='block';
					catHeader.style.backgroundColor="#7a8da9";//
					mainHeader.style.backgroundColor="#3e6aa9";//
				}else return;
			}
        
			catHeader.onclick=function(){
				if(catLst.style.display=='none'){
					mainLst.style.display='none';
					catLst.style.display='block';
					catHeader.style.backgroundColor="#3e6aa9";
					mainHeader.style.backgroundColor="#89a";
				}else return;
			}
    
			//console.log("d=",d);
			return;
		});
	}
	//mainLst.style.display='block';
	//catLst.style.display='none';
	//catHeader.style.backgroundColor="#3e6aa9";
	//TopMenu.mainHeader.style.backgroundColor="#aaa";
}

function formSearchSubmit(e){
	form = e.target.parentElement.parentElement;
	inpValue = form.querySelector("input[type=text]").value.trim();
	if(inpValue) form.submit();
}

/*Три функции для работы с Cookie*/
function createCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}
function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {
    createCookie(name,"",-1);
}

HTMLFormElement.prototype.serialize = function(){
    var obj = {};
    var elements = this.querySelectorAll( "input, select, textarea" );
    for( var i = 0; i < elements.length; ++i ) {
        var element = elements[i];
        var name = element.name;
        var value = element.value;

        if( name ) {
            obj[ name ] = value;
        }
    }
    //return JSON.stringify( obj );
	return obj;
}

/*Формируем заказ*/
var zakaz=[];
var rdCook=readCookie("zakaz");
if(rdCook) zakaz=JSON.parse(rdCook);

if(Object.keys(zakaz).length >0){
	document.getElementById("basket").style.color='red';
	//.classList.add("imgLeft");
}
//console.log("zakazCookie",zakaz);

function basketLst(){
	//var modalPrice = document.getElementById("price");
	var modalWin;
	modalWin = document.getElementById("price");
	//modalPrice.style.opacity='1';
	//modalPrice.style.pointerEvents='auto';
	var dForm = document.getElementById("dForm");
	dForm.innerHTML = '';
	var zl='';
	var defn={'tovar':'Товар','DN':'диаметр','quant':'кол-во','env':'среда','envT':'Температура среды','pressure':'Давление','materl':'Материал исполнения','connect':'Тип присоединения'};
    for( var i = 0; i < zakaz.length; ++i ) {
        var tov = zakaz[i];
		for(var key in tov){
			zl+=defn[key]+': '+tov[key]+', ';
		}
		zl=zl.substring(0, zl.length-2);//Убираем последнюю запятую и пробел в строке
		zl+='<br>';
    }
	dForm.innerHTML = zl;
	dForm.innerHTML += '<br>\
	<input name="tovName" type="hidden" value="'+zl+'">\
	<input name="org" type=text placeholder="Наименование организации" title=""><br>\
	<input name="name" type=text pattern="^[a-zA-Zа-яА-ЯёЁ ]+$" placeholder="Ваше имя" maxlength=30><br>\
	<input name="tel" type=tel pattern="^[\+0-9-]{11,17}$" placeholder="Ваш телефон" title=""><br>\
	<input type="email" name="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" placeholder="Ваш email"><br>\
	<input type="submit" value="Отправить"><br>';
	modalWin.style.opacity='1';
	modalWin.style.pointerEvents='auto';
}

function closeModalPrice(){
	var modalPrice = document.getElementById("price");
	modalPrice.style.opacity='0';
	modalPrice.style.pointerEvents='none';
}

function zakazAdd(f){
	var s=f.serialize();
	//var basket=document.getElementById("basket");
	//zakaz.tovar=f.elements.tovar.value+'|'+f.elements.DN.value+'|'+f.elements.env.value+'|'+f.elements.quant.value;
	//zakaz.DN=f.elements.DN.value
	//var tovarName=s['tovar'];
	//delete s['tovar'];
	for(var k in s){
		if(s[k]==""){
			alert('Заполните, пожалуйста, все поля формы');
			return false;
		}
	}
	zakaz[zakaz.length]=s;
	//console.log(zakaz);
	createCookie("zakaz",JSON.stringify(zakaz));
	document.getElementById("basket").style.color='red';
	//basket.setAttribute('href', '/basket.php');
	alert('Товар добавлен в корзину');
	return false;
}
/*
function ajax_get(url, callback) {
    xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
            //console.log('responseText:' + xmlhttp.responseText);
            try {
                //var data = JSON.parse(xmlhttp.responseText);
                imgData = JSON.parse(xmlhttp.responseText);
            } catch(err) {
                //console.log(err.message + " in " + xmlhttp.responseText);
                return;
            }
            callback();
        }
    };
    xmlhttp.open("GET", url, true);
    xmlhttp.send();
}
*/

//ajax_get('delFoto.php?id='+id+'&fn='+imgFn, function(d){return;})
function ajax_get(url, callback) {
	var xmlhttp = new XMLHttpRequest();
	xmlhttp.onreadystatechange = function() {
		if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
			//console.log('responseText:' + xmlhttp.responseText);
			try {
				//var data = JSON.parse(xmlhttp.responseText);
				//aCml.data = JSON.parse(xmlhttp.responseText);
				callback(xmlhttp.responseText);
			} catch(err) {
				//console.log(err.message + " in " + xmlhttp.responseText);
				return;
			}
		}
	};
	xmlhttp.open("GET", url, true);
	xmlhttp.send();
}
